var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3156 8.00082C14.3156 4.5127 11.4879 1.68503 7.99985 1.68503C6.34166 1.68503 4.83275 2.32405 3.70589 3.36924L4.84195 3.36924C5.19076 3.36924 5.47353 3.65201 5.47353 4.00082C5.47353 4.34963 5.19076 4.6324 4.84195 4.6324H2.31564C1.96683 4.6324 1.68406 4.34963 1.68406 4.00082L1.68406 1.47451C1.68406 1.1257 1.96683 0.842928 2.31564 0.842928C2.66444 0.842928 2.94721 1.1257 2.94721 1.47451V2.35171C4.28807 1.15161 6.05874 0.421875 7.99985 0.421875C12.1856 0.421875 15.5788 3.81509 15.5788 8.00082C15.5788 12.1866 12.1856 15.5798 7.99985 15.5798C3.81411 15.5798 0.420898 12.1866 0.420898 8.00082C0.420898 7.60646 0.451012 7.21918 0.509075 6.84107C0.556477 6.53236 0.830355 6.31661 1.14265 6.31661C1.52918 6.31661 1.80907 6.68562 1.75246 7.06802C1.7074 7.37244 1.68406 7.68385 1.68406 8.00082C1.68406 11.4889 4.51173 14.3166 7.99985 14.3166C11.4879 14.3166 14.3156 11.4889 14.3156 8.00082ZM8.4209 4.42188C8.4209 4.07307 8.13812 3.7903 7.78932 3.7903C7.44052 3.7903 7.15774 4.07307 7.15774 4.42188L7.15774 8.21135C7.15774 8.56015 7.44052 8.84293 7.78932 8.84293H9.89458C10.2434 8.84293 10.5262 8.56015 10.5262 8.21135C10.5262 7.86255 10.2434 7.57977 9.89458 7.57977H8.4209V4.42188Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.1adf01d68604609896199b8f0d5f979a.svg";
export { ForwardRef as ReactComponent };